import { useEffect, useState, type RefObject } from "react"

export function useScrollIndex(scrollRef: RefObject<HTMLElement | null>): number {
    const [activeIndex, setActiveIndex] = useState(0)

    useEffect(() => {
        const el = scrollRef.current
        if (!el) return

        const handleScroll = () => {
            const itemWidth = el.firstElementChild?.clientWidth ?? 1
            const gap = parseFloat(getComputedStyle(el).gap) || 0
            const index = Math.round(el.scrollLeft / (itemWidth + gap))
            setActiveIndex(index)
        }

        el.addEventListener("scroll", handleScroll, { passive: true })
        return () => el.removeEventListener("scroll", handleScroll)
    }, [scrollRef])

    return activeIndex
}
